import { Button } from 'primereact/button';
import Data from '../../../../components/Display/Data';

export default function DistributionItem({
  distribution,
  handleUpdateDistribution,
  handleDeleteDistribution
}) {
  return (
    <div className="w-fit flex flex-row items-center gap-x-3 rounded-lg shadow p-2">
      <Data key="author" label={'Nom'} value={distribution.alias} large />
      <Data key="role" label={'Rôle'} value={distribution.role} large />
      <div className="flex flex-row gap-x-3">
        <Button
          key={'update'}
          outlined
          onClick={handleUpdateDistribution}
          severity="secondary"
          icon="pi pi-pencil"
          text
          rounded
        />
        <Button
          key={'delete'}
          outlined
          onClick={handleDeleteDistribution}
          severity="danger"
          icon="pi pi-trash"
          text
          rounded
        />
      </div>
    </div>
  );
}
